import { Injectable } from '@angular/core';
import { Observable, of, delay, tap } from 'rxjs';
import { SessionService } from './session.service';
import { Session } from '../../interfaces/package/session.interface';

@Injectable({
    providedIn: 'root'
})
export class SessionMockService extends SessionService {
    private mockSessions: Session[] = [
        {
            id: 'sess-1',
            uniqueId: 'SESS001',
            batchId: 'batch-1',
            moduleId: 'mod-1',
            sessionType: 'Lecture',
            title: 'Introduction to Angular',
            description: 'Core concepts of Angular framework',
            sessionDate: '2024-05-10',
            startTime: '10:00',
            endTime: '12:00',
            meetingLink: 'https://meet.google.com/abc-defg-hij',
            status: 'Scheduled',
            createdAt: '2024-04-01T10:00:00Z'
        }
    ];

    override findAll(searchParam: any): Observable<any> {
        return of({
            content: this.mockSessions,
            page: { totalElements: this.mockSessions.length, number: 0, size: 10, totalPages: 1 }
        }).pipe(delay(500));
    }

    override find(id: string): Observable<Session> {
        const sess = this.mockSessions.find(s => s.id === id || s.uniqueId === id);
        return of(sess!).pipe(delay(500));
    }

    override findByBatchId(batchId: string): Observable<Session[]> {
        const filtered = this.mockSessions.filter(s => s.batchId === batchId);
        return of(filtered).pipe(delay(500));
    }

    override findByModuleId(moduleId: string): Observable<Session[]> {
        const filtered = this.mockSessions.filter(s => s.moduleId === moduleId);
        return of(filtered).pipe(delay(500));
    }

    override create(data: Partial<Session>): Observable<Session> {
        const newSession = {
            ...data,
            id: 'sess-' + Math.random().toString(36).substring(7),
            uniqueId: 'SESS' + Math.floor(Math.random() * 1000).toString().padStart(3, '0'),
            createdAt: new Date().toISOString()
        } as Session;
        this.mockSessions.push(newSession);
        return of(newSession).pipe(delay(1000)).pipe(tap(() => {
            this.toast.success('Session created successfully');
        }));
    }

    override update(id: string, data: Partial<Session>): Observable<Session> {
        const index = this.mockSessions.findIndex(s => s.id === id);
        if (index !== -1) {
            this.mockSessions[index] = { ...this.mockSessions[index], ...data } as Session;
        }
        return of(this.mockSessions[index]).pipe(delay(1000)).pipe(tap(() => {
            this.toast.success('Session updated successfully');
        }));
    }

    override delete(id: string): Observable<void> {
        this.mockSessions = this.mockSessions.filter(s => s.id !== id);
        return of(undefined).pipe(delay(800)).pipe(tap(() => {
            this.toast.success('Session deleted successfully');
        }));
    }
}
